import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import { GlobalFormats } from '../../classess/main/globalFormats';

import { User } from '../../classess/user/user';
import { Company } from '../../classess/company/company';
import { Customer } from '../../classess/customer/customer';
import { UserCompanyCustomer } from '../../classess/userCompanyCustomer/userCompanyCustomer';

import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';

import {
    getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj, getResponse, handleResponseMessageAsync,
    settings, styles, LoadingSection, awaitDelayAsync,
} from '../../helpers/main';
import { UserService } from '../../services/users/UserService';
import AccessDenied from '../main/AccessDenied';
import TableIndex from '../main/TableIndex';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, icons, images, labels, messages, timers } = settings;

const currentMethod = 'UserCompanyCustomersEditDetails';

export default function UserCompanyCustomersEditDetails({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const { id, } = useParams();

    const dtUserCompanyCustomersId = 'dtUserCompanyCustomers';
    const dtUserCompanyCustomersProcess = {
        add: '',
        delete: 'userCompanyCustomerDelete',
        details: '',
    };
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({ back: false, showLoading: true, });
    const isMount = useRef(true);

    const [user, setUser] = useState(User?.getClass({}, false));
    const [company, setCompany] = useState(Company?.getClass({}, false));

    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnBack',
            },
        },
        dataTables: {
            userCompanyCustomers: {
                inputs: {
                    search: {
                        id: `${dtUserCompanyCustomersId}_filter input`,
                        defaultClass: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtUserCompanyCustomersId}_length select`,
                        defaultClass: '',
                    },
                },
            },
        },
        icons: {
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            user: {
                id: 'inputUser',
            },
            company: {
                id: 'inputCompany',
            },
        },
        selects: {
        },
        spiners: {
        },
    };
    //#endregion variables

    //#region methods
    //#region userscompanycustomers
    const deleteUserCompanyCustomer = async ({
        e = {},
        id = '',
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'deleteUserCompanyCustomer';
        try {
            e?.preventDefault?.();

            //#region show message
            const msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.customer?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`
            };

            const swalProperties = {
                icon: settings.react.sweetAlert2.messages.types.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                confirmButtonColor: settings.colors.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: settings.colors.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region delete data (usercompanycustomer)
                        preConfirmResponse = await UserService.deleteCustomerAssignmentAsync({
                            auth: auth,
                            id: id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion delete data (usercompanycustomer)

                        //#region delete datatable (usercompanycustomer)
                        $(`#${dtUserCompanyCustomersId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);
                        //#endregion delete datatable (usercompanycustomer)

                        preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
                    } catch (ex) {
                        //#region error
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                        //#endregion error
                    }
                    return preConfirmResponse;
                },
            };

            const swalResult = await Swal.fire({ ...swalProperties });
            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: auth,
                    languageId: languageObj?.id,
                });
            }
        }
        return response;
    }
    //#endregion userscompanycustomers

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (general)
                response = await UserService.getCustomersWithDetailsByUserCompanyIdAsync({
                    auth: auth,
                    id: id,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                const companyData = response?.result?.company || {};
                setCompany(companyData);
                const customersData = response?.result?.customers || [];
                const userData = response?.result?.user || {};
                setUser(userData);
                const userCompany = response?.result?.userCompany || {};
                const userCompanyCustomersData = response?.result?.userCompanyCustomers || [];
                //#endregion get data (general)

                //#region set datatable
                if (!isUndNullEmp({ data: userCompany, subMethod: currentMethod })?.result &&
                    userCompany?.id > 0) {
                    response = setDataInDataTable({
                        userCompanyCustomersData: userCompanyCustomersData,
                        customersData: customersData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataTables';
        try {
            $(`#${dtUserCompanyCustomersId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.code?.[languageObj?.id], width: '15%', },
                    { title: labels?.description?.[languageObj?.id], width: '65%', },
                    { title: labels?.rif?.[languageObj?.id], width: '15%', className: '', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtUserCompaniesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setQueryCode';
        try {
            const tableBody = $(`#${dtUserCompanyCustomersId} tbody`);
            tableBody.on('click', 'tr', 'td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtUserCompanyCustomersId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case dtUserCompanyCustomersProcess.add:
                            break;
                        case dtUserCompanyCustomersProcess.details:
                            break;
                        case dtUserCompanyCustomersProcess.delete:
                            deleteUserCompanyCustomer({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        userCompanyCustomersData = [],
        customersData = [Customer?.getClass({}, false)],
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataInDataTable';
        try {
            const rowsDt = userCompanyCustomersData.map((userCompanyCustomer) => {
                const modelUserCompanyCustomer = UserCompanyCustomer?.getClass(userCompanyCustomer, false);
                const currentCustomerData = customersData.find(({ id }) => id === modelUserCompanyCustomer.customerId) || {};

                const customerData = {
                    secundaryId: currentCustomerData?.secundaryId || '',
                    name: currentCustomerData?.name || '',
                    rif: currentCustomerData?.rif || '',
                };

                const processButtons = [
                    {
                        isVisible: false,
                        showDivider: false,
                        isEnabled: false,
                        methodName: dtUserCompanyCustomersProcess.add,
                        icon: icons?.fasFa?.plusCircle,
                        label: `${labels?.add?.[languageObj?.id]}`
                    },
                    {
                        isVisible: false,
                        showDivider: false,
                        isEnabled: false,
                        methodName: dtUserCompanyCustomersProcess.details,
                        icon: icons?.fasFa?.list,
                        label: `${labels?.details?.[languageObj?.id]}`
                    },
                    {
                        isVisible: true,
                        showDivider: false,
                        isEnabled: true,
                        methodName: dtUserCompanyCustomersProcess.delete,
                        icon: icons?.fasFa?.trash,
                        label: `${labels?.delete?.[languageObj?.id]}`
                    },
                ];

                return [
                    customerData.secundaryId,
                    customerData.name,
                    customerData.rif,
                    getProcessButtons({
                        id: modelUserCompanyCustomer?.id || 0,
                        description: customerData.name,
                        showDetails: false,
                        labelDetails: labels?.details?.[languageObj?.id],
                        enabledDetails: false,
                        showDelete: false,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: false,
                        showEdit: false,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: false,
                        processButtons: processButtons,
                    })?.result,
                ];
            });

            $(`#${dtUserCompanyCustomersId}`).DataTable().rows.add(rowsDt).draw(true);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const gotoBack = async ({
        e = undefined,
        subMethod = '',
    }) => {
        const currentMethod = 'gotoBack';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, back: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            window.location.href = `${backend?.urls?.users}/${user?.id}`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount) return;

            setProcess(prev => ({ ...prev, back: false, showLoading: false }));

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad', });
        return () => {
            isMount.current = false;
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={app?.views?.settings?.settings} process={app?.views?.users?.user} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.user?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={backend?.urls?.users}>{labels?.users?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={`${backend?.urls?.users}/${user?.id || ''}`}>{labels?.user?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.userCompanyDetails?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.users?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.user}></img>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.edit?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-warning text-dark px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.userEdit} mr-1`}></i> {labels?.edit?.[languageObj?.id] || 'Edit'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <form onSubmit={(e) => e.preventDefault()}>
                                                    <div className='row'>
                                                        <div className='col-12 col-md-6'>
                                                            <div className='form-group mb-4'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                    <i className={`${icons?.fasFa?.user} mr-1`} /> {labels?.user?.[languageObj?.id]}
                                                                </small>
                                                                <input id={controls?.inputs?.user.id}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    style={{ borderRadius: '5px' }}
                                                                    value={`${user?.firstName || ''} - ${user?.lastName || ''}` || '---'}
                                                                    placeholder={labels?.user?.[languageObj?.id]}
                                                                    readOnly
                                                                    title={labels?.user?.[languageObj?.id]} />
                                                            </div>
                                                        </div>
                                                        <div className='col-12 col-md-6'>
                                                            <div className='form-group mb-4'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                    <i className={`${icons?.fasFa?.building} mr-1`} /> {labels?.company?.[languageObj?.id]}
                                                                </small>
                                                                <input id={controls?.inputs?.company.id}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    style={{ borderRadius: '5px' }}
                                                                    value={company?.name || '---'}
                                                                    placeholder={labels?.company?.[languageObj?.id]}
                                                                    readOnly
                                                                    title={labels?.company?.[languageObj?.id]} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='d-flex flex-wrap justify-content-end align-items-center mt-3 mb-2'
                                                        style={{ gap: '8px' }}>
                                                        <button id={controls?.buttons?.back?.id}
                                                            className={controls?.buttons?.back?.defaultClass}
                                                            style={{ borderRadius: '5px' }}
                                                            title={labels?.back?.[languageObj?.id]}
                                                            onClick={(e) => { gotoBack({ e: e, subMethod: controls?.buttons?.back?.id }) }}
                                                            type='button'>
                                                            {process?.back ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true' />
                                                            ) : (
                                                                <i id={controls?.icons?.back?.id} className={`${controls?.icons?.back?.defaultClass}`} />
                                                            )} {labels?.back?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </form>

                                                <div className='d-flex align-items-center mt-4 mb-2'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.fileAlt} text-secondary`} style={{ fontSize: '12px' }}></i>
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.customers?.[languageObj?.id]}</h6>
                                                </div>
                                                <TableIndex tableId={dtUserCompanyCustomersId} languageObj={languageObj} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}

                    </div>
                </section>
            </div>
        </div>
    )
}